import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'g99-nx-welcome',
  template: `
    <style>
      /* reviews.component.css */
      .reviews-container {
        text-align: center;
        margin: 20px;
      }

      .back-button {
        padding: 10px 20px;
        font-size: 16px;
        cursor: pointer;
        background-color: #007bff;
        color: white;
        border: none;
        border-radius: 5px;
        transition: background-color 0.3s;
      }

      .back-button:hover {
        background-color: #0056b3;
      }
    </style>
    <div class="reviews-container">
      <h1>Welcome to the Reviews Page</h1>
      <p>Your feedback is important to us!</p>

      <button type="button" class="back-button" (click)="goBackToOldUI()">
        Click below to go back to the old UI screen
      </button>
    </div>
  `,
  styles: [],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NxWelcomeComponent {
  public goBackToOldUI() {
    // Construct the new URL
    const newUrl = 'https://devemr.growthemr.com';
    window.location.href = newUrl;
  }
}
